import React, { useEffect, useState } from "react";
import { api } from "../../app/Api/ApiSlice";
import { toast } from "react-toastify";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { updateProfile, updateNames } from "../../app/slices/authSlice";
import UserImage from "../../assets/user.png"

const Edit = () => {
    const location = useLocation()
    const { user } = location.state

    // console.log(user)

    // Loading states
    const [isLoading, setIsLoading] = useState(false);
    const [savingImg, setSavingImg] = useState(false);
    const [savingDetails, setSavingDetails] = useState(false);
    const [savingAddress, setSavingAddress] = useState(false);
    const [savingContacts, setSavingContacts] = useState(false);

    // Profile
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");

    // Address
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");

    // Contacts
    const [email, setEmail] = useState("");
    const [website, setWebsite] = useState("");
    const [phone, setPhone] = useState("");
    const [currentImg,setCurrentImg] = useState({})

    // Media
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState("");

    // Fetch user data
    useEffect(() => {
        const getUser = async () => {
            try {
                setIsLoading(true);
                const { data } = await api.get(`/account/profile`);

                // console.log("userData:", data)

                setFirstname(data.firstname || "");
                setLastname(data.lastname || "");

                setCountry(data.country || "");
                setState(data.state || "");
                setCity(data.city || "");

                setEmail(data.email || "");
                setWebsite(data.website || "");
                setPhone(data.phone || "");

                setCurrentImg(data.profilePics.current)
            } catch (err) {
                console.log(err)
                toast.error(err?.response?.data?.message || "Failed to load settings");
            } finally {
                setIsLoading(false);
            }
        };

        getUser();
    }, []);

    // Upload helper
    const uploadToS3 = async (file) => {
        const presignRes = await api.post("/uploads/presign", {
            filename: file.name,
            contentType: file.type,
        });

        const { uploadUrl, key } = presignRes.data;

        const res = await fetch(uploadUrl, {
            method: "PUT",
            headers: { "Content-Type": file.type },
            body: file,
        });

        if (!res.ok) throw new Error("Upload failed");

        return {
            key,
            type: "image",
            mimeType: file.type,
            name: file.name,
            size: file.size,
        };
    };

    // Logo
    const handleLogoUpload = async (e) => {
        e.preventDefault();
        if (!image) return;

        try {
            setSavingImg(true);
            const uploadedFile = await uploadToS3(image);
            const res = await api.post(`/account/profile/image`, {
                file: uploadedFile,
            });

            console.log("image:", res)
            updateProfile(res.data)

            toast.success("profile updated");
        } catch (err) {
            console.log(err)
            toast.error(err?.message || "Upload failed");
        } finally {
            setSavingImg(false);
        }
    };

    // Details
    const handleUpdateDetails = async (e) => {
        e.preventDefault();

        try {
            setSavingDetails(true);
            await api.patch(`/account/profile/details`, { firstname, lastname });
            toast.success("Details updated");
        } catch (err) {
            toast.error(err?.response?.data?.message || "Update failed");
        } finally {
            setSavingDetails(false);
        }
    };

    // Address
    const handleUpdateAddress = async (e) => {
        e.preventDefault();

        try {
            setSavingAddress(true);
            await api.put(`/account/profile/address`, {
                country,
                state,
                city,
            });
            toast.success("Address updated");
        } catch (err) {
            toast.error(err?.response?.data?.message || "Update failed");
        } finally {
            setSavingAddress(false);
        }
    };

    // Contacts
    const handleUpdateContacts = async (e) => {
        e.preventDefault();

        try {
            setSavingContacts(true);
            await api.put(`/account/profile/contacts`, {
                email,
                website,
                phone,
            });
            toast.success("Contacts updated");
        } catch (err) {
            toast.error(err?.response?.data?.message || "Update failed");
        } finally {
            setSavingContacts(false);
        }
    };

    if (isLoading) {
        return (
            <div className="loader">
                <Loader />
            </div>
        );
    }

    return (
        <div className="profile-settings-container">
            <header className="settings-header">
                <h1>Profile Settings</h1>
                <p>My public profile and contact details.</p>
            </header>

            {/* Branding */}
            <section className="settings-card">
                <div className="logo-upload-section">
                    <div className="org-logo-preview">
                        {imagePreview ? (
                            <img src={imagePreview} alt="Logo" />
                        ) : (
                            <img src={currentImg ? currentImg.url : UserImage} alt="" className="logo" />

                        )}
                    </div>

                    <div className="upload-controls">
                        <input
                            type="file"
                            id="logo-input"
                            accept="image/*"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    setImage(file);
                                    setImagePreview(URL.createObjectURL(file));
                                }
                            }}
                        />

                        <button
                            className="btn-save"
                            onClick={handleLogoUpload}
                            disabled={savingImg}
                        >
                            {savingImg ? "Uploading..." : "Save Logo"}
                        </button>
                    </div>
                </div>
            </section>

            {/* Details */}
            <section className="settings-card">
                <h3>General Details</h3>
                <form onSubmit={handleUpdateDetails}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Firstname</label>
                            <input value={firstname} onChange={(e) => setFirstname(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Lastname</label>
                            <input value={lastname} onChange={(e) => setLastname(e.target.value)} />
                        </div>

                        <button className="btn-save" type="submit" disabled={savingDetails}>
                            {savingDetails ? "Saving..." : "Update Details"}
                        </button>
                    </div>
                </form>
            </section>

            {/* Address */}
            <section className="settings-card">
                <h3>Address Information</h3>
                <form onSubmit={handleUpdateAddress}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Country</label>
                            <input value={country} onChange={(e) => setCountry(e.target.value)} />
                        </div>

                        <div className="form-group">
                            <label>State/Province</label>
                            <input value={state} onChange={(e) => setState(e.target.value)} />
                        </div>

                        <div className="form-group">
                            <label>City</label>
                            <input value={city} onChange={(e) => setCity(e.target.value)} />
                        </div>
                    </div>

                    <button className="btn-save" type="submit" disabled={savingAddress}>
                        {savingAddress ? "Saving..." : "Update Address"}
                    </button>
                </form>
            </section>

            {/* Contacts */}
            <section className="settings-card">
                <h3>Contact Information</h3>
                <form onSubmit={handleUpdateContacts}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Public Email</label>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>

                        <div className="form-group">
                            <label>Website URL</label>
                            <input type="url" value={website} onChange={(e) => setWebsite(e.target.value)} />
                        </div>

                        <div className="form-group">
                            <label>Primary Phone</label>
                            <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} />
                        </div>
                    </div>

                    <button className="btn-save" type="submit" disabled={savingContacts}>
                        {savingContacts ? "Saving..." : "Update Contacts"}
                    </button>
                </form>
            </section>
        </div>
    );
};

export default Edit;
